import Strapi from 'strapi-sdk-javascript'

export const LS = {
  get JWT () {
    return window.localStorage.getItem('JWT-CELL-API-HEROKU-CELL-GAME')
  },
  set JWT (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('JWT-CELL-API-HEROKU-CELL-GAME')
      return
    }
    return window.localStorage.setItem('JWT-CELL-API-HEROKU-CELL-GAME', val)
  },

  get UserID () {
    return window.localStorage.getItem('UserID-CELL-API-HEROKU-CELL-GAME')
  },
  set UserID (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('UserID-CELL-API-HEROKU-CELL-GAME')
      return
    }
    return window.localStorage.setItem('UserID-CELL-API-HEROKU-CELL-GAME', val)
  },

  get LoggedIn () {
    return window.localStorage.getItem('LoggedIn-CELL-API-HEROKU-CELL-GAME')
  },
  set LoggedIn (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('LoggedIn-CELL-API-HEROKU-CELL-GAME')
      return
    }
    return window.localStorage.setItem('LoggedIn-CELL-API-HEROKU-CELL-GAME', val)
  },

  get Profile () {
    return JSON.parse(window.localStorage.getItem('Profile-CELL-API-HEROKU-CELL-GAME') || 'false')
  },
  set Profile (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('Profile-CELL-API-HEROKU-CELL-GAME')
      return
    }
    return window.localStorage.setItem('Profile-CELL-API-HEROKU-CELL-GAME', JSON.stringify(val))
  }
}

export const getCurrentUserID = () => {
  if (LS.LoggedIn) {
    return LS.UserID
  } else {
    return false
  }
}

export const checkLogin = () => {
  return !!LS.LoggedIn
}

export const checkIsPALMS = () => {
  if (checkLogin()) {
    return LS.Profile.role.name === 'palms' || LS.Profile.role.type === 'palms'
  } else {
    return false
  }
}

export const getBaseURL = () => {
  let baseURL = 'https://api.the-cell-game.com'
  if (process.env.NODE_ENV === 'development') {
    baseURL = `http://localhost:1337`
  }
  return baseURL
}

let storeConfig = {
  cookie: {
    key: 'api-the-cell-game-com',
    options: {
      path: '/'
    }
  },
  localStorage: {
    key: 'api-the-cell-game-com'
  }
}
// oauth
export const strapi = new Strapi('https://api.the-cell-game.com', storeConfig)
window.strapi = strapi

export const facebookLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('facebook')
  // window.location = `https://www.facebook.com/dialog/oauth?client_id=473491293443303&response_type=code&redirect_uri=${encodeURIComponent(`https://api.the-cell-game.com`)}%2Fconnect%2Ffacebook%2Fcallback&scope=email`
}

export const googleLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('google')
  // window.location = `https://accounts.google.com/o/oauth2/auth?client_id=1074577189258-48bbotqbk71sgs8rlfnpunq5v277lt7e.apps.googleusercontent.com&response_type=code&redirect_uri=${encodeURIComponent(`https://api.the-cell-game.com`)}%2Fconnect%2Fgoogle%2Fcallback&scope=email`
}
export const twitterLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('twitter')
  // window.location = `https://accounts.google.com/o/oauth2/auth?client_id=1074577189258-48bbotqbk71sgs8rlfnpunq5v277lt7e.apps.googleusercontent.com&response_type=code&redirect_uri=${encodeURIComponent(`https://api.the-cell-game.com`)}%2Fconnect%2Fgoogle%2Fcallback&scope=email`
}
export const facebookArrive = () => {
  // Complete the authentication: (The SDK will store the access token for you)
  return strapi.authenticateProvider('facebook')
    .then(() => {
      LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
      return getMe()
        .then((me) => {
          LS.UserID = me._id
          LS.Profile = me
          LS.LoggedIn = true

          return true
        })
    }, () => {
      return false
    })
}

export const twitterArrive = () => {
  // Complete the authentication: (The SDK will store the access token for you)
  return strapi.authenticateProvider('twitter')
    .then(() => {
      LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
      return getMe()
        .then((me) => {
          LS.UserID = me._id
          LS.Profile = me
          LS.LoggedIn = true

          return true
        })
    }, () => {
      return false
    })
}

export const googleArrive = () => {
  return new Promise((resolve, reject) => {
    // Complete the authentication: (The SDK will store the access token for you)
    // let queryString = require('query-string')
    // let info = queryString.parse(window.location.search, {
    //   arrayFormat: 'bracket'
    // })
    // console.log(info)
    // LS.JWT = info.access_token
    // strapi.request('get',
    //   `/auth/google/callback?access_token=${info.access_token}`
    // )
    // strapi.request('get',
    //   `/auth/google/callback?access_token=${info.raw.id_token}`
    // )
    strapi.authenticateProvider('google')
      .then(() => {
        LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
        return getMe()
          .then((me) => {
            LS.UserID = me._id
            LS.Profile = me
            LS.LoggedIn = true

            resolve(true)
          }, () => {
            reject(new Error('email taken'))
          })
      }, () => {
        reject(new Error('email taken'))
      })
  })
}

export const strap = () => {
  let headers = {
    Authorization: `Bearer ${LS.JWT}`
  }
  let axios = require('axios')

  let baseURL = getBaseURL()

  if (!LS.JWT) {
    delete headers.Authorization
  }
  return axios.create({
    baseURL,
    headers
  })
}

export const register = ({ username, email, password }) => {
  return strap()
    .post('/auth/local/register', {
      username,
      email,
      password
    })
    .then(response => {
      // Handle success.
      console.log('Well done!')
      // console.log('User profile', response.data.user)
      // console.log('User token', response.data.jwt)

      LS.JWT = response.data.jwt
      LS.UserID = response.data.user._id
      LS.Profile = response.data.user
      LS.LoggedIn = true

      return response.data
    })
    // .catch(error => {
    //   // Handle error.
    //   console.log('An error occurred:', error)
    // })
}

export const login = ({ identifier, password }) => {
  return strap()
    .post('/auth/local', {
      identifier,
      password
    })
    .then(response => {
      // Handle success.
      console.log('Well done!')
      // console.log('User profile', response.data.user)
      // console.log('User token', response.data.jwt)
      LS.JWT = response.data.jwt
      LS.UserID = response.data.user._id
      LS.Profile = response.data.user
      LS.LoggedIn = true

      return response.data
    })
    // .catch(error => {
    //   // Handle error.
    //   console.log('An error occurred:', error)
    // })
}

export const logout = () => {
  LS.JWT = false
  LS.UserID = false
  LS.LoggedIn = false
  LS.Profile = false
}

export const getMe = () => {
  return strap()
    .get('/users/me')
    .then(res => {
      return res.data
    })
}

export const createGame = ({ width, height, enableEntryPassword, userID, question, flags, displayName, slug }) => {
  let cells = [
  ]
  let cid = 0
  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x++) {
      cells.push({
        x,
        y,
        cid: cid,
        core: false,
        lvl: 0,
        uid: 'map'
      })
      cid++
    }
  }

  return strap()
    .post(`/games`, {
      width,
      height,
      enableEntryPassword,
      userID,
      question,
      flags,
      cells,
      displayName,
      slug
    })
    .then(res => {
      return res.data
    })
}

export const checkDuplicateSlug = ({ slug }) => {
  return strap()
    .get(`/games/count?slug=${slug}`)
    .then((res) => {
      return res.data === 0
    })
}

export const setRoomPassword = ({ gameID, userID, entryPassword }) => {
  return strap()
    .post(`/gamesecrets`, {
      gameID,
      userID,
      entryPassword
    })
    .then((res) => {
      return res.data
    })
}

export const searchRoomList = ({ displayName }) => {
  return strap()
    .get(`/games/search?search=${displayName}`)
    .then(res => {
      return res.data
    })
}

export const getPinnedIDs = () => {
  return strap()
    .get(`/pintops`)
    .then(res => {
      return res.data
    })
}

export const getPinnedDetails = ({ ids }) => {
  return strap()
    .get(`/games/pinned?ids=${ids.join(',')}`)
    .then(res => {
      return res.data
    })
}

export const pinGame = ({ gameID }) => {
  return strap()
    .post(`/pintops`, { gameID })
    .then(res => {
      return res.data
    })
}

export const removePin = ({ pinID }) => {
  return strap()
    .delete(`/pintops/${pinID}`)
    .then(res => {
      return res.data
    })
}

export const getIO = async () => {
  let io = require('socket.io-client')
  let baseURL = getBaseURL()
  let socket = io(`${baseURL}`)
  return socket
}

export const removeGame = async ({ gameID, userID }) => {
  return Promise.all([
    strap()
      .delete(`/games/removeGame?userID=${userID}&gameID=${encodeURIComponent(gameID)}`)
      .then(res => {
        return res.data
      })
  ])
}

export const getPlayerCount = async ({ gameID }) => {
  return strap()
    .get(`/players/count?gameID=${encodeURIComponent(gameID)}`)
    .then(res => {
      return res.data
    })
}

// checkPassword
export const checkPassword = async ({ gameID, entryPassword }) => {
  return strap()
    .post(`/games/checkPW?gameID=${encodeURIComponent(gameID)}&entryPassword=${encodeURIComponent(entryPassword)}`)
    .then(res => {
      return res.data
    })
}

export const getGameDetail = ({ gameID }) => {
  return strap()
    .get(`/games/${gameID}`)
    .then(res => {
      return res.data
    })
}

export const getMyGames = ({ userID }) => {
  return strap()
    .get(`/games/?userID=${userID}`)
    .then(res => {
      return res.data
    })
}

export const updateMyGame = ({ userID, field, value, gameID }) => {
  return strap()
    .post(`/games/updateGame`, { userID, field, value, gameID })
    .then(res => {
      return res.data
    })
}

export const updateMyGameSecret = ({ userID, field, value, gameID }) => {
  return strap()
    .post(`/games/updateGameSecret`, { userID, field, value, gameID })
    .then(res => {
      return res.data
    })
}

export const Game = {
  startLevel: 5,
  maxCellCoreLevel: 5
}

export const getDifficultyAndMode = ({ game, myself, players, cell }) => {
  let level = ''
  if (cell.uid === 'map') {
    level = 'easy'
  } else if (cell.core) {
    level = 'hard'
  } else if (cell.lvl >= 2) {
    level = 'hard'
  } else if (cell.lvl >= 1) {
    level = 'hard'
  } else if (cell.lvl >= 0) {
    level = 'medium'
  }
  let closeOnly = false
  let mode = false
  let displayMsg = ``
  if (cell.uid === 'map') {
    mode = 'captureEmptyCell'
    displayMsg = 'Capture new cell?'
  } else if (cell.uid !== myself.userID) {
    if (cell.core) {
      if (cell.lvl >= 1) {
        mode = 'downGradeCellCore'
        displayMsg = 'Downgrade Others Cell Core?'
      } else {
        mode = 'captureCellCore'
        displayMsg = 'Capture Others Cell Core?'
      }
    } else {
      if (cell.lvl >= 1) {
        mode = 'downGradeCell'
        displayMsg = 'Downgrade Others Cell?'
      } else {
        mode = 'captureCell'
        displayMsg = 'Capture Others Cell?'
      }
    }
  } else if (cell.uid === myself.userID) {
    if (cell.core) {
      if (cell.lvl < Game.maxCellCoreLevel) {
        mode = 'upgradeCellCore'
        displayMsg = 'Upgrade Cell Core?'
      } else {
        mode = 'upgradeCellCoreMax'
        displayMsg = 'Upgrade Maxed Out'
        closeOnly = true
      }
    } else {
      if (cell.lvl < 1) {
        mode = 'upgradeCell'
        displayMsg = 'Upgrade Cell?'
      } else {
        mode = 'upgradeCellMax'
        displayMsg = 'Upgrade Maxed Out'
        closeOnly = true
      }
    }
  }

  return {
    level, mode, displayMsg, closeOnly
  }
}

export const getQCounter = async () => {
  let axios = require('axios')
  return axios
    .get(`https://yo-analytics.herokuapp.com/responses/count`)
    .then(res => {
      return res.data
    })
}
